<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditModal"
        persistent
        max-width="500px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              >
                <span class="headline">
                  {{ isUpdate ? $t('finance.updateCurrencyRateTitle') : $t('finance.addCurrencyRateTitle') }}
                </span>
              </v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('finance.sellRateLabel', { code: 'IQD' }) + ' *'"
                    v-model="formData.ex_rate"
                    :error-messages="errors.collect('IQD Rate')"
                    v-validate="'required|decimal:4'"
                    data-vv-name="IQD Rate"
                    type="number"
                    step="0.0001"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('finance.buyRateLabel', { code: 'IQD' })"
                    v-model="formData.ex_buy_rate"
                    :error-messages="errors.collect('IQD Buy Rate')"
                    v-validate="'decimal:4'"
                    data-vv-name="IQD Buy Rate"
                    type="number"
                    step="0.0001"
                    :placeholder="$t('common.example', { value: '1310.00' })"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('finance.sellRateLabel', { code: 'TL' })"
                    v-model="formData.tl_rate"
                    :error-messages="errors.collect('TL Rate')"
                    v-validate="'decimal:4'"
                    data-vv-name="TL Rate"
                    type="number"
                    step="0.0001"
                    :placeholder="$t('common.example', { value: '32.50' })"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('finance.buyRateLabel', { code: 'TL' })"
                    v-model="formData.tl_buy_rate"
                    :error-messages="errors.collect('TL Buy Rate')"
                    v-validate="'decimal:4'"
                    data-vv-name="TL Buy Rate"
                    type="number"
                    step="0.0001"
                    :placeholder="$t('common.example', { value: '35.00' })"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('finance.sellRateLabel', { code: 'AED' })"
                    v-model="formData.aed_rate"
                    :error-messages="errors.collect('AED Rate')"
                    v-validate="'decimal:4'"
                    data-vv-name="AED Rate"
                    type="number"
                    step="0.0001"
                    :placeholder="$t('common.example', { value: '3.67' })"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('finance.buyRateLabel', { code: 'AED' })"
                    v-model="formData.aed_buy_rate"
                    :error-messages="errors.collect('AED Buy Rate')"
                    v-validate="'decimal:4'"
                    data-vv-name="AED Buy Rate"
                    type="number"
                    step="0.0001"
                    :placeholder="$t('common.example', { value: '3.80' })"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('finance.sellRateLabel', { code: 'CNY' })"
                    v-model="formData.cny_rate"
                    :error-messages="errors.collect('CNY Rate')"
                    v-validate="'decimal:4'"
                    data-vv-name="CNY Rate"
                    type="number"
                    step="0.0001"
                    :placeholder="$t('common.example', { value: '7.25' })"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('finance.buyRateLabel', { code: 'CNY' })"
                    v-model="formData.cny_buy_rate"
                    :error-messages="errors.collect('CNY Buy Rate')"
                    v-validate="'decimal:4'"
                    data-vv-name="CNY Buy Rate"
                    type="number"
                    step="0.0001"
                    :placeholder="$t('common.example', { value: '7.50' })"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('finance.sellRateLabel', { code: 'GBP' })"
                    v-model="formData.gbp_rate"
                    :error-messages="errors.collect('GBP Rate')"
                    v-validate="'decimal:4'"
                    data-vv-name="GBP Rate"
                    type="number"
                    step="0.0001"
                    :placeholder="$t('common.example', { value: '0.79' })"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('finance.buyRateLabel', { code: 'GBP' })"
                    v-model="formData.gbp_buy_rate"
                    :error-messages="errors.collect('GBP Buy Rate')"
                    v-validate="'decimal:4'"
                    data-vv-name="GBP Buy Rate"
                    type="number"
                    step="0.0001"
                    :placeholder="$t('common.example', { value: '0.82' })"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('finance.sellRateLabel', { code: 'EUR' })"
                    v-model="formData.eur_rate"
                    :error-messages="errors.collect('EUR Rate')"
                    v-validate="'decimal:4'"
                    data-vv-name="EUR Rate"
                    type="number"
                    step="0.0001"
                    :placeholder="$t('common.example', { value: '0.92' })"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('finance.buyRateLabel', { code: 'EUR' })"
                    v-model="formData.eur_buy_rate"
                    :error-messages="errors.collect('EUR Buy Rate')"
                    v-validate="'decimal:4'"
                    data-vv-name="EUR Buy Rate"
                    type="number"
                    step="0.0001"
                    :placeholder="$t('common.example', { value: '0.95' })"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto" class="submit-btn-spacing"
                outline
                color="success"
              >
                {{ isUpdate ? $t('common.save') : $t('common.add') }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['addEditModal', 'formData', 'isUpdate'],

  data() {
    return {
      loading: false
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.isUpdate) {
            Axios.put(`api/currency-rate/${this.formData.currency_rate_id}`, this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: this.$t('common.updatedSuccessfully'),
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal(this.$t('common.error'), error.response.data.message, 'error')
              })
          } else {
            Axios.post('api/currency-rate', this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: this.$t('common.addedSuccessfully'),
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal(this.$t('common.error'), error.response.data.message, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/currencyRate/addEdit.vue